import { useCallback, useContext, useEffect } from 'react'
import { AuthContext } from 'contexts/AuthContext'
import { getProfilePromise, getPartnerGoalPromise } from 'apis/Auth'
import { ProfileModel } from 'models/User'
import { getPartnerId } from 'utils/authLocalStorage'

export const checkOnboarding = async (authContext) => {
  const [_p, _g] = await Promise.all([
    getProfilePromise(authContext),
    getPartnerGoalPromise(),
  ])
  const pResult = ProfileModel.validate(_p, { stripUnknown: true })
  const gResult = !!_g?.userGoals?.length

  return {
    profileValid: !pResult.error,
    goalValid: gResult,
    _p,
    _g,
  }
}

export const useReviveOnboardingCheck = ({
  isRevive,
  autoLoginLoading,
  history,
  initialUrl,
}) => {
  const authContext = useContext(AuthContext)

  const checkOnboardingStatus = useCallback(async () => {
    const { profileValid, goalValid } = await checkOnboarding(authContext)

    if (!profileValid || !goalValid) {
      history.replace('/partner/revive/onboarding', {
        redirect: initialUrl !== '/partner/revive/onboarding' ? initialUrl : '',
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!autoLoginLoading && isRevive && getPartnerId()) {
      checkOnboardingStatus()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRevive, autoLoginLoading])
}
